import r2wc from "@r2wc/react-to-web-component";
import reportWebVitals from "./reportWebVitals";
import { RegisterForm } from "./RegisterForm";
import "./i18n";
import "./styles/main.css";

// Configurar opciones globales de reCAPTCHA
window.recaptchaOptions = {
  useRecaptchaNet: true,
  enterprise: true,
};

const MFRegisterForm = r2wc(RegisterForm);
customElements.define("mf-formulario-registro", MFRegisterForm);

// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
